import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';

export const Header = ({ onCTAClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-white/90 backdrop-blur-xl border-b border-border/40 sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="header-logo">
            <img src="/logo.png" alt="Get Logo Trademarked" className="h-12 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <button onClick={() => scrollToSection('services')} className="text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">Services</button>
            <button onClick={() => scrollToSection('about')} className="text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">About</button>
            <button onClick={() => scrollToSection('pricing')} className="text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">Pricing</button>
            <button onClick={() => scrollToSection('faq')} className="text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">FAQ</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors">Contact</button>
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a href="tel:+11231234567" className="text-sm text-muted-foreground hover:text-primary transition-colors">+1 (123) 123-4567</a>
            <Button onClick={onCTAClick} className="bg-primary hover:bg-primary/90 text-white" data-testid="header-cta-button">
              Register My Trademark
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-button"
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-4 space-y-4" data-testid="mobile-menu">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2">Services</button>
            <button onClick={() => scrollToSection('about')} className="block w-full text-left text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2">About</button>
            <button onClick={() => scrollToSection('pricing')} className="block w-full text-left text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2">Pricing</button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2">FAQ</button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-sm uppercase tracking-widest text-muted-foreground hover:text-primary transition-colors py-2">Contact</button>
            <Button onClick={onCTAClick} className="w-full bg-primary hover:bg-primary/90 text-white">Register My Trademark</Button>
          </div>
        )}
      </div>
    </header>
  );
};